<template>
  <div class="sub-page">
    <div class="page-header">
      <div class="back-btn" @click="onBack">
        <svg viewBox="0 0 24 24" class="back-icon"><path d="M15 18 L9 12 L15 6" fill="none" stroke="#323233" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="page-title">{{ title }}</div>
      <div class="header-right"><slot name="header-right"></slot></div>
    </div>
    <div class="page-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubPage',
  props: {
    title: { type: String, default: '' }
  },
  methods: {
    // 父组件监听 @back 时优先由父组件处理（用于页面内视图切换），否则默认路由返回
    onBack() {
      if (this.$listeners.back) {
        this.$emit('back')
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
.sub-page {
  background: #F3F8FB;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.page-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(112 * var(--w));
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  flex-shrink: 0;
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(48 * var(--w));
  height: calc(48 * var(--w));
  cursor: pointer;
}
.back-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.page-title {
  font-size: calc(46 * var(--w));
  font-weight: 500;
  color: #323233;
}
.header-right {
  position: absolute;
  right: calc(32 * var(--w));
  top: 50%;
  transform: translateY(-50%);
}
.page-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  /* 纵向弹性布局：子页面 flex:1 可100%撑满，保证背景铺满整屏 */
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/SubPage.vue